import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import style from "./styles";
import { isHighReturner } from "../../utils/isHighReturner";
import { NotificationBar } from "@asosteam/asos-web-component-library-notification-bar";

const PremierDeliveryNotice = ({
  countriesData,
  premierDeliveryNotice,
  premierHighReturnerMessage,
  assetsUrl,
  appConfig,
}) => {
  const [highReturner, setHighReturner] = useState(false);

  useEffect(() => {
    const checkCustomer = async () => {
      const result = await isHighReturner(appConfig);
      setHighReturner(result);
    };
    checkCustomer();
  }, [appConfig]);

  if (highReturner) {
    const isProduction = window.location.host === "www.asos.com";
    const myAsosDomain = isProduction
      ? "https://my.asos.com"
      : "https://my.asosservices.com";

    const { title, message, linkText } = premierHighReturnerMessage;

    return (
      <>
        <NotificationBar
          closeButtonAriaLabel="Close"
          onClose={null}
          type="alert"
        >
          <h2 className={style.bannerTitle}>{title}</h2>
          <p className={style.bannerText}>{message}</p>
          <a
            href={`${myAsosDomain}/my-account/orders`}
            className={style.bannerLink}
          >
            {linkText}
          </a>
        </NotificationBar>
      </>
    );
  }

  return (
    <div
      className={style.PremierBanner}
      style={{ backgroundColor: premierDeliveryNotice.fillColor }}
    >
      <div className={style.imageContainer}>
        <img
          src={`${assetsUrl}/premier-landing-page/img/png/world.png`}
          alt=""
        />
      </div>
      <div className={style.contentContainer}>
        <h2 className={style.bannerTitle}>
          {premierDeliveryNotice.text.replace(
            "%countriesNum%",
            countriesData.length
          )}
        </h2>
      </div>
    </div>
  );
};

PremierDeliveryNotice.propTypes = {
  countriesData: PropTypes.arrayOf(PropTypes.object).isRequired,
  premierDeliveryNotice: PropTypes.object.isRequired,
  premierHighReturnerMessage: PropTypes.object.isRequired,
  assetsUrl: PropTypes.string,
  appConfig: PropTypes.object,
};

export default PremierDeliveryNotice;
